import React, { useState, useRef, useEffect } from 'react';
import { useAuth } from '../contexts/AuthContext';
import '../styles/components/UserProfileDropdown.css';

interface UserProfileDropdownProps {
  userAvatar: string;
  userName: string;
  userEmail: string;
}

const UserProfileDropdown: React.FC<UserProfileDropdownProps> = ({
  userAvatar,
  userName,
  userEmail,
}) => {
  const [isOpen, setIsOpen] = useState(false);
  const dropdownRef = useRef<HTMLDivElement>(null);
  const { user, logout } = useAuth();

  // Close dropdown when clicking outside
  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target as Node)) {
        setIsOpen(false);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);

  const handleAvatarClick = () => {
    setIsOpen(!isOpen);
  };

  const handleLogout = async () => {
    try {
      await logout();
      setIsOpen(false);
    } catch (error) {
      console.error('Logout failed:', error);
    }
  };

  return (
    <div className={`user-profile-dropdown ${isOpen ? 'open' : ''}`} ref={dropdownRef}>
      <div 
        className="avatar-container"
        onClick={handleAvatarClick}
        title="Click to view profile"
      >
        <div className="user-avatar">{userAvatar}</div>
        <div className="dropdown-arrow">▼</div>
      </div>
      
      {isOpen && (
        <div className="dropdown-menu">
          <div className="dropdown-header">
            <div className="dropdown-avatar">{userAvatar}</div>
            <div className="dropdown-user-info">
              <div className="dropdown-user-name">{userName}</div>
              <div className="dropdown-user-email">{userEmail}</div>
            </div>
          </div>
          
          <div className="dropdown-divider"></div>
          
          <div className="dropdown-details">
            {user?.department && (
              <div className="dropdown-item">
                <span className="dropdown-label">Department:</span>
                <span className="dropdown-value">{user.department}</span>
              </div>
            )}
            {user?.role && (
              <div className="dropdown-item">
                <span className="dropdown-label">Role:</span>
                <span className="dropdown-value">{user.role}</span>
              </div>
            )}
            {user?.tenant && (
              <div className="dropdown-item">
                <span className="dropdown-label">Tenant:</span>
                <span className="dropdown-value">{user.tenant}</span>
              </div>
            )}
          </div>
          
          <div className="dropdown-divider"></div>
          
          <button 
            className="dropdown-logout-button"
            onClick={handleLogout}
          >
            Logout
          </button>
        </div>
      )}
    </div>
  );
};

export default UserProfileDropdown; 